import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private appState = inject(AppState);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.appState.isInErrorState$.next(false);

    return next.handle(req);
  }
}
